/**
 * Groupes de rôles partagés par la table des routes et le menu : un seul
 * endroit déclare « qui voit quoi » côté console (la vérification qui fait
 * foi reste celle du backend).
 */
import { UserRole } from '../types/rbac';

/** Administrateurs (admin et super admin). */
export const ADMINS: UserRole[] = [UserRole.ADMIN, UserRole.SUPER_ADMIN];

/** Super administrateurs seulement. */
export const SUPER_ADMINS: UserRole[] = [UserRole.SUPER_ADMIN];
